/** @jsx jsx */
import { FC, useCallback } from 'react';
import { jsx } from '@emotion/core';

import { Wallet } from 'state/instantCredit';
import styles from './styles';

interface PropTypes {
  wallet: Wallet;
  onClick: (wallet: Wallet) => void;
  id?: string;
  disabled?: boolean;
}

const PermanentWalletButton: FC<PropTypes> = props => {
  const { wallet, onClick, disabled, id } = props;

  const handleClick = useCallback(() => {
    onClick(wallet);
  }, [onClick, wallet]);

  return (
    <div css={styles.container}>
      <button css={styles.button} id={id} disabled={disabled}>
        <img
          src={`data:${wallet.assetType};base64,${wallet.assetData}`}
          css={styles.img}
          alt={`${wallet.consumerFacingEntityName}`}
          onClick={handleClick}
        />
      </button>
    </div>
  );
};

export default PermanentWalletButton;
